<template>
   <div class="user-center">
     <div class="user-container flex">
       <div class="left-content">
         <div class="qy-item">
           <div>
             <img src="../../assets/images/my/qy.png" alt="">
           </div>
           <div>
             {{userInfo.department_name}}
           </div>
         </div>
         <div class="left-item" @click="navTo('/userInfo')" :class="$route.path=='/userInfo'||$route.path=='/editInfo'?'active':''" >
           <img src="../../assets/images/my/jcxx.png" alt="">基础信息
         </div>
<!--         <div class="left-item" @click="navTo('/buyRecords')" :class="$route.path=='/buyRecords'?'active':''">购买记录</div>-->
         <div class="left-item" @click="navTo('/contactPage')" :class="$route.path=='/contactPage'||$route.path=='/addContact'?'active':''">
           <img src="../../assets/images/my/lxrgl.png" alt=""> 授权代表
         </div>
         <div class="left-item" @click="navTo('/invoiceRecord')" :class="$route.path=='/invoicePage'||$route.path=='/invoiceRecord'||$route.path=='/addInvoice'?'active':''">
           <img src="../../assets/images/my/kpgl.png" alt="">开票管理
         </div>
         <div class="left-item" @click="navTo('/userMsg')" :class="$route.path=='/userMsg'?'active':''">
           <img src="../../assets/images/my/xtxx.png" alt="">系统消息
         </div>
         <div class="left-item" @click="navTo('/suggestion')" :class="$route.path=='/suggestion'?'active':''">
           <img src="../../assets/images/my/yjfk.png" alt=""> 意见反馈
         </div>
         <div class="left-item" @click="navTo('/changePwd')" :class="$route.path=='/changePwd'?'active':''">
           <img src="../../assets/images/my/xgmm.png" alt=""> 修改密码
         </div>
       </div>
       <div class="right-content">
         <router-view class="router-view" ></router-view>
       </div>
     </div>
   </div>
</template>

<script>
//import {userInfo} from "node:os";

export default {
  name: "userCenter",
  data(){
    return{
      routeName:''
    }
  },
  computed:{
    userInfo(){
      return this.$store.state.userInfo;
    }
  },
  mounted(){
    this.routeName=this.$route.path
  },
  methods:{
    getUrl(){
      this.routeName=this.$route.path
    }
  }
}
</script>

<style  lang="scss">
 .user-center{
   padding: 37px 0 28px;
   .user-container{
     width: 1200px;
     margin: 0 auto;
     .left-content{
       width: 293px;
       height: 480px;
       background: #032055;
       border-radius: 10px;
       //display: flex;
       //flex-direction: column;
       //align-items: center;
       padding-top: 25px;
       .qy-item{
         text-align: center;
         font-weight: 500;
         font-size: 18px;
         color: #FFFFFF;
         margin-bottom: 34px;
         img{
          width: 98px;
           height: 98px;
         }
       }
       .left-item{
         cursor: pointer;
         height: 46px;
         padding-left: 21px;
         font-size: 14px;
         font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
         font-weight: 500;
         color: #fff;
         border-left:2px solid transparent; ;
         display: flex;
         align-items: center;
         img{
           width: 30px;
           height: 30px;
           margin-right: 5px;
         }
       //  background-color: #F6F6F6;

       }
       .active{
         background: #002867;
         border-left-color: #1565F7;
       }
     }
     .right-content{
       width: 892px;
       min-height: 509px;
       background: #FFFFFF;
       border-radius: 10px;
       margin-left: 17px;
       padding-bottom: 20px;
       .title-content{
         //border-bottom: 1px solid #D8D8D8;
         padding-top: 20px;
         padding-left: 34px;
         .title{
           padding-left: 10px;
           font-weight: 500;
           font-size: 18px;
           color: #1565F7;
           border-left: 2px solid #1565F7;
         }
         //.line{
         //  margin-top:10px;
         //  height: 4px ;
         //  width:89px;
         //  background-color: #F42323;
         //  border-radius:50px
         //}
       }
       .page-view{
         text-align: right;
       }
     }
   }
 }

</style>
